export interface Regiao {
    id: number;
    nome: string;
    grupo: GruposRegiao | string;
    estados?: EstadoRegiao[] | null;
    created_at?: string | null | undefined;
    updated_at?: string | null | undefined;
}

export interface EstadoRegiao {
    estado_id?: string;
    id?: number;
    created_at?: string | null | undefined;
    updated_at?: string | null | undefined;
}

export interface Estado {
    id: string;
    nome: string;
    ibge: number;
}

export enum GruposRegiao {
    REGIAO = "Região",
    ESTADOS = "Estado",
    OUTROS = "Outros",
}

export type SiglasEstados = null | "AC" | "AL" | "AP" | "AM" | "BA" | "CE" | "ES" | "GO" | "MA" | "MT" | "MS" | "MG" | "PA" | "PB" | "PR" | "PE" | "PI" | "RJ" | "RN" | "RS" | "RO" | "RR" | "SC" | "SP" | "SE" | "TO" | "DF";

export interface Cidade {
    cidade_codigo: number | null
    estado_id: SiglasEstados
    id: number
    nome: string
}


// Contas
export const TIPO_CONTA_DISTRIBUIDOR = 1;
export const TIPO_CONTA_DISTRIBUIDOR_ENGAJADO = 2;
export const TIPO_CONTA_REVENDA = 3;
export const TIPO_CONTA_INTEGRADOR = 4;
export const TIPO_CONTA_CLIENTE_FINAL = 5;
export const TIPO_CONTA_EV = 6;
export const TIPO_CONTA_SUPERVISOR = 8;
export const TIPO_CONTA_ASSISTENTE = 9;
export const TIPO_CONTA_COLABORADOR = 10;
export const TIPO_CONTA_VAREJO = 11;

export const LIST_TIPO_CONTA_DISTRIBUIDORES = [TIPO_CONTA_DISTRIBUIDOR, TIPO_CONTA_DISTRIBUIDOR_ENGAJADO, TIPO_CONTA_VAREJO];
export const LIST_TIPO_CONTA_REVENDAS = [TIPO_CONTA_REVENDA, TIPO_CONTA_INTEGRADOR];

export interface ContasClassificacao {
    id: number;
    cnpj_cpf: string;
    nome: string;
    fantasia: string;
    tipo_conta_id: number | null;
    classificacao_conta_id?: number | null;
    auto_classificar_conta: boolean;
    data_classificacao: string | null;
    data_proxima_classificacao: string | null;
}

export interface ContasVinculos {
    id: number;
    cnpj_cpf: string;
    nome: string;
    fantasia: string;
    tipo_conta_id: number | null;
    vinculos?: ContaVinculos[];
}

export type TTipoVinculo = "distribuidor" | "matriz" |
    "ev_distribuicao_ongrid" | "ev_distribuicao_offgrid" | "ev_verticais_ongrid" | "ev_verticais_offgrid" |
    "supervisor_distribuicao_ongrid" | "supervisor_distribuicao_offgrid" | "supervisor_verticais_ongrid" | "supervisor_verticais_offgrid" |
    "assistente_distribuicao_ongrid" | "assistente_distribuicao_offgrid" | "assistente_verticais_ongrid" | "assistente_verticais_offgrid";

export interface ContaVinculos {
    tipo: TTipoVinculo;
    conta_vinculo_id?: number;
    vinculo?: Conta;
    created_at?: string | Date;
    updated_at?: string | Date;
    "@remove"?: boolean;
}

export interface ContasVinculosEdit {
    id: number;
    vinculos: ContaVinculos[];
}

export interface ContasClassificacaoEdit {
    id: number;
    classificacao_conta_id: number | null;
    auto_classificar_conta: boolean;
    data_classificacao?: string | null;
}

export interface Conta {
    id?: number;
    auto_classificar_conta?: boolean;
    cidade?: Cidade;
    cidade_codigo?: number;
    estado_id?: string;
    nome: string;
    cidade_integracao?: string;
    classificacao_conta_id?: number;
    cnpj_cpf?: string;
    email?: string;
    fantasia?: string;
    telefone?: string;
    tipo_conta_id?: number;
    user_guilted_id?: number | null;
    data_ativacao?: string;
    data_classificacao?: string | null;
    data_proxima_classificacao?: string | null;
    logradouro?: string;
    bairro?: string;
    cep?: string;
    numero?: string;
    complemento?: string;
    created_at?: string | null;
    updated_at?: string | null;
    permite_servico?: boolean | null
    segmentos_servico?: string[] | null
}

export interface Upload {
    id?: number;
    tipo: string;
    url: string;
    created_at?: string;
    updated_at?: string | null;
    validade?: string | null;
    origem?: string | null;
    ["@remove"]?: boolean;
}

export interface IUploadConfig {
    url:  string;
    port: number;
}
